<template>
  <!-- 睡眠検査機器配送ｻｰﾋﾞｽ案件確認 -->
  <div id="HSTRequestSearch">
    <div id="container">
      <!-- tab bar area -->
      <HSTNavBar v-bind:pageid="'HSTRequestSearch'" />
      <div class="labelTitle">睡眠検査機器配送ｻｰﾋﾞｽ 案件確認</div>
      <!-- 検索条件エリア -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td>
              <input type="text" v-model="searchConditions.receiptNumber" maxlength="20" />
            </td>
            <th>デモ</th>
            <td>
              <select v-model="searchConditions.demo">
                <option
                  v-for="type in demoList"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.name }}
                </option>
              </select>
            </td>
            <th>機種</th>
            <td>
              <select v-model="searchConditions.modelId">
                <option
                  v-for="device in HSTDeviceList"
                  :value="device.value"
                  :key="device.value"
                >
                  {{ device.label1 }}
                </option>
              </select>
            </td>
            <th>ステータス</th>
            <td>
              <select v-model="searchConditions.status">
                <option
                  v-for="status in statusList"
                  :key="status.value"
                  :value="status.value"
                >
                  {{ status.name }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>シリアル</th>
            <td>
              <input type="text" v-model="searchConditions.serial" maxlength="100" />
            </td>
            <th>依頼元</th>
            <td>
              <input type="text" v-model="searchConditions.client" />
            </td>
            <th>患者名</th>
            <td>
              <input type="text" v-model="searchConditions.patientName" maxlength="100" />
            </td>
          </tr>
          <tr>
            <th>送り状番号</th>
            <td>
              <input type="text" v-model="searchConditions.invoiceNumber" maxlength="256" />
            </td>
            <th>着払い番号</th>
            <td>
              <input type="text" v-model="searchConditions.paymentNumber" maxlength="256" />
            </td>
          </tr>
          <tr>
            <th>受付日</th>
            <td colspan="3">
              <input type="date" v-model="searchConditions.receptionDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.receptionDateEnd" />
            </td>
            <th>出荷日</th>
            <td colspan="3">
              <input type="date" v-model="searchConditions.shippingDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.shippingDateEnd" />
            </td>
          </tr>
          <tr>
            <th>機器返却日</th>
            <td colspan="3">
              <input type="date" v-model="searchConditions.returnDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.returnDateEnd" />
            </td>
            <th>解析依頼日</th>
            <td colspan="3">
              <input type="date" v-model="searchConditions.analysisRequestDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.analysisRequestDateEnd" />
            </td>
          </tr>
          <tr>
            <th>解析日</th>
            <td colspan="3">
              <input type="date" v-model="searchConditions.analysisDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.analysisDateEnd" />
            </td>
            <th>完了日</th>
            <td colspan="7">
              <input type="date" v-model="searchConditions.completionDateStart" />
              <span>～</span>
              <input type="date" v-model="searchConditions.completionDateEnd" />
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果表示エリア -->
      <div class="result-area" v-show="showResult">
        <div class="float-area">
          <b-button
            style="margin-right: 10px"
            class="clipboadCopyButton is-primary"
            @click="copyToClipboard"
            >クリップボードにコピー</b-button
          >
          <b-button
            v-if="!showSelectColMenu"
            @click="showSelectColMenu = !showSelectColMenu"
            class="is-primary"
            icon-left="table-column-width"
            >列選択</b-button
          >
          <b-button
            v-if="showSelectColMenu"
            @click="showSelectColMenu = false"
            class="is-primary"
            icon-left="close-box-outline"
            >閉じる</b-button
          >
          <!-- 表示列選択エリア -->
          <div v-if="showSelectColMenu" style="clear: both; height: 0px">
            <div class="box selectColumn">
              <div style="height: 30px">
                <b-checkbox
                  class="columnCheckBox"
                  v-model="allColChecked"
                  @input="allCheck"
                  >全てチェック</b-checkbox
                >
                <a style="float: right" @click="showSelectColMenu = false">
                  <b-icon icon="close" />
                </a>
              </div>
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.receiptNumber.checked"
                >受付番号</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.demo.checked"
                >デモ</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.modelId.checked"
                >機種</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.status.checked"
                >ステータス</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.serial.checked"
                >シリアル</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.branchOfficeName.checked"
                >支店名</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.salesStaffName.checked"
                >担当者名</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.client.checked"
                >依頼元</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.patientName.checked"
                >患者名</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.receptionDate.checked"
                >受付日</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.shippingDate.checked"
                >出荷日</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.returnDate.checked"
                >機器返却日</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.analysisRequestDate.checked"
                >解析依頼日</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.analysisDate.checked"
                >解析日</b-checkbox
              >
              <b-checkbox
                class="columnCheckBox"
                v-model="columns.completionDate.checked"
                >完了日</b-checkbox
              >
            </div>
          </div>
        </div>
        <!-- 検索結果表示TB -->
        <span class="result-count" style="position: relative; top:6px;">件数：{{data.length}}件</span>
        <b-table
          id="hst-search-result-table"
          :data="data"
          per-page="100"
          :paginated="true"
          pagination-position="both"
          default-sort="receiptNumber"
          aria-previous-label="Previous page"
          aria-next-label="Next page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              :visible="columns.receiptNumber.checked"
              field="receiptNumber"
              label="受付番号"
              centered
              sortable
            >
              <router-link
                :to="{
                  name: 'HSTRequestSearchDetail',
                  params: {
                    item: props.row,
                    searchConditions: searchConditions,
                    statusList: statusList,
                  },
                }"
              >
                {{ props.row.receiptNumber }}
              </router-link>
            </b-table-column>
            <b-table-column
              :visible="columns.demo.checked"
              field="demo"
              label="デモ"
              sortable
            >
              <span v-if="props.row.demo">デモ</span>
            </b-table-column>
            <b-table-column
              :visible="columns.modelId.checked"
              field="modelId"
              label="機種"
              sortable
              >{{
                getChoiceName(props.row.modelId, HSTDeviceList)
              }}</b-table-column
            >
            <b-table-column
              :visible="columns.status.checked"
              field="status"
              label="ステータス"
              centered
              sortable
            >
              <span :class="getTagClass(props.row.status)">{{
                getStatusName(props.row.status)
              }}</span>
            </b-table-column>
            <b-table-column
              :visible="columns.serial.checked"
              field="serial"
              label="シリアル"
              sortable
              >{{ props.row.serial }}</b-table-column
            >
            <b-table-column
              :visible="columns.branchOfficeName.checked"
              field="branchOfficeName"
              label="支店名"
              sortable
              >{{ props.row.branchOfficeName }}</b-table-column
            >
            <b-table-column
              :visible="columns.salesStaffName.checked"
              field="salesStaffName"
              label="担当者名"
              sortable
            >
              {{ props.row.salesStaffName }}
            </b-table-column>
            <b-table-column
              :visible="columns.client.checked"
              field="client"
              label="依頼元"
              sortable
            >
              {{ props.row.client }}
              <span v-if="props.row.proxyFlag" class="agent" />
            </b-table-column>
            <b-table-column
              :visible="columns.patientName.checked"
              field="patientName"
              label="患者名"
              sortable
              >{{ props.row.patientName }}</b-table-column
            >
            <b-table-column
              :visible="columns.receptionDate.checked"
              field="receptionDate"
              label="受付日"
              centered
              sortable
              >{{ props.row.receptionDate }}</b-table-column
            >
            <b-table-column
              :visible="columns.shippingDate.checked"
              field="shippingDate"
              label="出荷日"
              centered
              sortable
              >{{ props.row.shippingDate }}</b-table-column
            >
            <b-table-column
              :visible="columns.returnDate.checked"
              field="returnDate"
              label="機器返却日"
              centered
              sortable
              >{{ props.row.returnDate }}</b-table-column
            >
            <b-table-column
              :visible="columns.analysisRequestDate.checked"
              field="analysisRequestDate"
              label="解析依頼日"
              centered
              sortable
              >{{ props.row.analysisRequestDate }}</b-table-column
            >
            <b-table-column
              :visible="columns.analysisDate.checked"
              field="analysisDate"
              label="解析日"
              centered
              sortable
              >{{ props.row.analysisDate }}</b-table-column
            >
            <b-table-column
              :visible="columns.completionDate.checked"
              field="completionDate"
              label="完了日"
              centered
              sortable
              >{{ props.row.completionDate }}</b-table-column
            >
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { choicesType, role } from "../../base/const.js";
import HSTNavBar from "./HSTNaviBar.vue";

export default {
  name: "HSTRequestSearch",
  components: {
    HSTNavBar,
  },

  data() {
    return {
      // 検索条件エリア
      searchConditions: {
        // 受付番号
        receiptNumber: "",
        // デモ
        demo: "",
        // 機種
        modelId: "",
        // ステータス
        status: [],
        // シリアル
        serial: "",
        // 依頼元
        client: "",
        // 患者名
        patientName: "",
        // 送り状番号
        invoiceNumber: "",
        // 着払い番号
        paymentNumber: "",
        // 受付日 from
        receptionDateStart: "",
        // 受付日 to
        receptionDateEnd: "",
        // 出荷日 from
        shippingDateStart: "",
        // 出荷日 to
        shippingDateEnd: "",
        // 機器返却日 from
        returnDateStart: "",
        // 機器返却日 to
        returnDateEnd: "",
        // 解析依頼日 from
        analysisRequestDateStart: "",
        // 解析依頼日 to
        analysisRequestDateEnd: "",
        // 解析日 from
        analysisDateStart: "",
        // 解析日 to
        analysisDateEnd: "",
        // 完了日 from
        completionDateStart: "",
        // 完了日 to
        completionDateEnd: "",
      },
      // 「機種」select list
      HSTDeviceList: [{}],
      // 「デモ」select list
      demoList: [
        { name: "" },
        { name: "含まない", value: false },
        { name: "デモのみ", value: true },
      ],
      // 「ステータス」select list
      statusList: [
        { name: "", value: [] },
        { name: "未受付", value: [1] },
        { name: "受付済", value: [2] },
        { name: "出荷準備中", value: [3] },
        { name: "出荷済み", value: [4] },
        { name: "機器受領中", value: [5] },
        { name: "解析依頼中", value: [6,7] },
        { name: "解析中", value: [8] },
        { name: "結果確認中", value: [9] },
        { name: "結果送付待", value: [10] },
        { name: "再検査調整中", value: [16] },
        { name: "完了", value: [13,14,15,18] },
        { name: "キャンセル", value: [17] },
      ],

      // 「列選択」check box list (with default setting)
      columns: {
        receiptNumber: { checked: true },
        demo: { checked: true },
        modelId: { checked: true },
        status: { checked: true },
        serial: { checked: true },
        branchOfficeName: { checked: true },
        salesStaffName: { checked: true },
        client: { checked: true },
        clientType: { checked: true },
        companyName: { checked: true },
        patientName: { checked: true },
        receptionDate: { checked: true },
        shippingDate: { checked: true },
        returnDate: { checked: true },
        analysisRequestDate: { checked: true },
        analysisDate: { checked: true },
        completionDate: { checked: true },
      },

      // 「列選択」 show select column table.
      showSelectColMenu: false,
      // 「列選択」 all check boxes.
      allColChecked: true,

      // b-table's "data"
      data: [],
      // show result area.
      showResult: false,
    };
  },

  methods: {
    doSearch: function(){
      var isSearchParam = false;
      var keys = Object.keys(this.searchConditions);
      for (var i = 0; i < keys.length; i++) {
        if (this.searchConditions[keys[i]]+"" !="" && this.searchConditions[keys[i]] !="[]") {
          isSearchParam = true;
          break;
        }
      }
      if (!isSearchParam) {
        this.showErrorMessage("検索条件が入力されていません。");
        return;
      }
      this.data = []
      this.showResult = false;
      var excuteApi = this.getHSTRequestSearchPOST;
      var successCallBack = this.getHSTRequestSearchPOSTSuccess;
      var errorCallBack = this.getHSTRequestSearchPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHSTRequestSearchPOST: function(client) {
      var _this = this;
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalHst.getHSTRequestSearchPOST({
        body:obj
      });
    },
    getHSTRequestSearchPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.showResult = true;
    },
    getHSTRequestSearchPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getStatusName(statusCode) {
      var statusName = "";
      var finding = this.statusList.find(
        (s) => s.value && s.value.includes(statusCode)
      );
      if (finding) {
        statusName = finding.name;
      }
      return statusName;
    },

    getChoiceName(prop, list) {
      var label = "";
      var finding = list.find((item) => item.value == prop);
      if (finding) {
        label = finding.label1;
      }
      return label;
    },

    allCheck() {
      Object.values(this.columns).map(
        (column) => (column.checked = this.allColChecked)
      );
    },

    copyToClipboard() {
      var bTable = document.getElementById("hst-search-result-table");
      var tableWrapper = bTable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      navigator.clipboard
        .writeText(tbody.innerText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch((err) => {
          this.showMessage("コピーに失敗しました");
        });
    },
  },

  created() {
    this.HSTDeviceList = this.HSTDeviceList.concat(
      this.getChoiceList(choicesType.hstKind, false)
    );
  },

  mounted() {
    if (!this.$route.params.searchConditions) return;
    this.searchConditions = this.$route.params.searchConditions;
    this.doSearch();
  },
};
</script>

<style scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}
.float-area {
  float: left;
}
</style>
<style>
#hst-search-result-table .table-wrapper {
  overflow: auto;
  max-width: 100%;
}
#hst-search-result-table thead th {
  white-space: nowrap !important;
}
#hst-search-result-table tbody td {
  font-size: 100%;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTRequestSearch.vue